import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import "../../assets/scss/pages/common.scss"
import CustomerSetup from "../customer/customerSetup";
const mql = window.matchMedia(`(min-width: 992px)`)

class CustomerSelector extends Component {
  state = {
    sidebarDocked: mql.matches,
    sidebarOpen: false
  }

  UNSAFE_componentWillMount() {
    console.log("Mounted")
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    console.log("Unmounted")
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen = open => {
    this.setState({ sidebarOpen: open });
  }

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
  }

  render() {
    return (
      <div>
        <CustomerSetup
          sidebarOpen={this.state.sidebarOpen}
          sidebarDocked={this.state.sidebarDocked}
          onSetSidebarOpen={(value) => this.onSetSidebarOpen(value)}
          contentSharing={this.props.contentSharing}
          toggle={this.props.toggle}
        />
      </div>
    );
  }
}

export default CustomerSelector;